module.exports = __webpack_public_path__ + "static/media/cases_impressos_nec_01.f2f29a61.jpg";